import { createTheme, ThemeProvider } from '@mui/material';

const defaultTheme = createTheme(); //Create a default theme

interface DefaultThemeWrapperProps {
	children: React.ReactNode;
}

// Create a wrapper component that applies the default theme
const DefaultThemeWrapper: React.FC<DefaultThemeWrapperProps> = ({ children }) => {
	return (
	<ThemeProvider theme={defaultTheme}>
		{children}
	</ThemeProvider>
	);
};

export default DefaultThemeWrapper;